import { TwsAdmin } from '@weddingspot/ws-api-client';
export { TwsAdmin };

export interface VenueManagementState {
    // Current item being displayed
    activeItem: ActiveItem;
    activeItemTouched: boolean;
}

export interface VideoData {
    url: string | null;
    order: number | null;
}

export interface ContactInfo {
    id: number;
    first_name: string;
    last_name: string;
    email: string;
    account_created: boolean;
    phone_number: string;
    is_primary: boolean;
    receive_appointments: boolean;
    receive_invoices: boolean;
    receive_approval_requests: boolean;
    receive_metrics_emails: boolean;
    access_venue_metrics: boolean;
}

export interface WeddingPacketFileInfo {
    file_id: number;
    name: string;
    url: string;
    size_bytes: number;
}

export interface GeneralInformationFormData {
    /* About */
    venue_name: string;
    description: string;
    is_wedding_venue: boolean;
    is_rd_venue: boolean;
    is_dw_venue: boolean;

    /* Address */
    address_1: string;
    address_2: string;
    city: string;
    state: string;
    zip_code: string;
    country: string;
    province: string;

    market: string | null;
    lock_market: boolean;
    region_1: string | null;
    lock_region_1: boolean;
    region_2: string | null;
    lock_region_2: boolean;
    is_private_address: boolean;
    cross_region_market: string | null;
    lock_cross_region_market: boolean;
    cross_region: string | null;
    lock_cross_region: boolean;

    /* Contacts */
    contacts: ContactInfo[];

    /* Media */
    videos: VideoData[];
    wedding_packet_email_subject: string | null;
    wedding_packet_email_body: string | null;
    wedding_packet_files_to_upload: File[];

    /* Styles */
    styles: number[];

    /* Links */
    website_url: string | null;
    facebook_url: string | null;
    instagram_url: string | null;
    pinterest_url: string | null;
}

export enum ActiveItem {
    PREVIEW,
    GENERAL,
    AVAILABILITY,
    PRICING,
    AMENITIES,
}

export enum SeasonAvailabilityType {
    ALL_YEAR = '1',
    PEAK = '2',
    OFFPEAK = '3',
}

export enum ExtraHoursChargeType {
    PER_HOUR = 1,
    PER_PERSON_PER_HOUR = 2,
}

export interface AvailabilityFormData {
    allocated_hours: number;
    season_availability: SeasonAvailabilityType;
    peak_month_override: number[];
    availability_description: string;
    availability_start_time: string | null;
    availability_end_time: string | null;
    max_event_hours: number | null;
    extra_hours_charge_type: ExtraHoursChargeType | null;
    fees_per_extra_hour: number | null;
}

export interface AmenitiesFormData {
    amenities: number[];
    restrictions: number[];
    kitchen_facilities: number;
    catering_option: number;
    alcohol_policy: number;
    smoking_policy: number;
    music_policy: number;
    music_end_time: string;
    parking_option: number;
}
